/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Redirect } from 'react-router';

import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';

import CreateChannelMutation from '../mutations/CreateChannelMutation';
import Card from './Card';

class CreateChannel extends React.Component {
  constructor(props) {
    super(props);
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this.state = { redirect: null };
  }

  cancel(e) {
    e.preventDefault();
    return this.props.history.goBack();
  }

  submit(e) {
    e.preventDefault();
    const onSuccess = resp => {
      return this.setState({
        redirect: `/channels/${resp.createChannel.channelEdge.node.id}`,
      });
    };
    return CreateChannelMutation.commit(
      this.state.name,
      this.props.viewer,
      onSuccess,
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <div className="max-w-2xl mx-auto w-full">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Create a Channel</h1>
          <p className="text-gray-600">Create a new channel to organize your notifications</p>
        </div>
        <Card>
          <form
            className="flex flex-col p-6"
            onSubmit={this.submit}
          >
            <div className="flex flex-col space-y-3 mb-6">
              <Label htmlFor="channel-name" className="text-sm font-medium text-gray-700">
                Channel Name
              </Label>
              <Input
                id="channel-name"
                onChange={e => this.setState({ name: e.target.value })}
                value={this.state.name || ''}
                autoFocus
                className="w-full"
                placeholder="e.g. Production Alerts, Team Updates"
              />
              <p className="text-xs text-gray-500">
                Choose a descriptive name that helps identify the purpose of this channel
              </p>
            </div>
            <div className="flex gap-3 justify-end pt-4 border-t border-gray-200">
              <Button type="button" variant="outline" onClick={this.cancel}>
                Cancel
              </Button>
              <Button type="submit" disabled={this.state.loading || !this.state.name}>
                {this.state.loading ? 'Creating...' : 'Create Channel'}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    );
  }
}

export default CreateChannel;
